module.exports = (__webpack_require__(1))(37);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/actions/externalNavTo.js from dll-reference rlink_core
// module id = 567
// module chunks = 0